function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import PageData from '../page/Page.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import PosillicoLandingPageAdd from './PosillicoLandingPageAdd.modal';
import PosillicoLandingPageArticle from './PosillicoLandingPageArticle.react';
var PosillicoLandingPage = function PosillicoLandingPage(_ref) {
  var addModalAction = _ref.addModalAction;
  var _useContext = useContext(PageData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var pageID = state.pageID,
    reactComponent = state.reactComponent,
    posillicoLandingPage = state.posillicoLandingPage;
  if (reactComponent !== 'posillico-landing-page') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Posillico Landing Page",
    button: {
      label: 'Add Article',
      type: 'add',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(PosillicoLandingPageAdd, {
            pageID: pageID
          })
        });
      }
    }
  })), posillicoLandingPage === null || posillicoLandingPage === void 0 ? void 0 : posillicoLandingPage.map(function (x) {
    return /*#__PURE__*/React.createElement(PosillicoLandingPageArticle, {
      article: x,
      pageID: pageID,
      key: x._id
    });
  }));
};
var mdtp = {
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(PosillicoLandingPage);